// Mock data and API helpers for KG Auto Redesign
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const servicesData = [
  {
    id: "mobile-mechanic-service",
    title: "Mobile Mechanic Service",
    subtitle: "Morgantown, Fairmont, Preston County and beyond!",
    image: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f",
    summary: "Get your vehicle fixed right where you are. Our mobile units bring professional diagnostics and repairs directly to your location with no tow bills.",
    description: "At KG Auto Repair, we understand that vehicle maintenance can be stressful and inconvenient. That's why we bring our expert automotive service directly to you! Skip the towing fee and the waiting room - our fully-equipped mobile units handle professional diagnostics and repairs wherever your car is parked.",
    benefits: [
      "Auto repair delivered directly to your home, office, or roadside",
      "No towing bill or hassle of arranging rides",
      "Lower overhead costs, saving you money on parts & labor",
      "24/7 direct mechanic communication and roadside assistance"
    ],
    details: {
      sectionTitle: "Scheduling Your Mobile Auto Repair",
      sectionText: "We cover a wide range of over 55 miles, providing reliable auto repairs in Morgantown, Kingwood, Fairmont, Clarksburg, Rowlesburg, Masontown, Arthurdale, and surrounding areas. Our scheduling is flexible, and we work efficiently to get you back on the road in no time. Call or text now for a free mobile service quote!",
      extraServices: [
        "On-site diagnostic scanning",
        "Mobile Brake & Rotor Replacement",
        "Emergency Roadside Start/Battery Swap",
        "Mobile Oil & Fluid Changes",
        "AC & Heat on-the-spot Repairs"
      ]
    }
  },
  {
    id: "engine-rebuilding-and-repair",
    title: "Engine Rebuilding & Repair",
    subtitle: "Timing kits, head gaskets, complete swaps, and custom builds",
    image: "https://images.unsplash.com/photo-1527383418406-f85a3b146499",
    summary: "From timing chains to complete custom engine rebuilds and swaps. High-horsepower track builds or reliable daily drivers, we do it all with care.",
    description: "Your engine is the heart of your vehicle. When complex issues arise, you need technicians with deep technical expertise and professional-grade precision. KG Auto Repair offers comprehensive engine diagnostic, repair, rebuilding, and swapping services. We treat every vehicle with absolute care, ensuring your motor performs at its peak.",
    benefits: [
      "Advanced computer diagnostics to read error codes correctly",
      "Timing belts, chains, head gaskets, and full top-end head rebuilds",
      "Complete engine replacements/swaps for all major vehicle makes",
      "Warranty-backed parts and labor for peace of mind"
    ],
    details: {
      sectionTitle: "Common Signs of Engine Troubles",
      sectionText: "Do not wait until a minor symptom turns into complete engine failure. Contact us immediately if you experience:",
      extraServices: [
        "Active Check Engine warning light",
        "Knocking, tapping, or metallic engine sounds",
        "Visible oil leaks or excessive oil consumption",
        "Rough idling, frequent stalling, or sudden power loss",
        "Burning smell or dark exhaust smoke"
      ],
      brands: [
        "BMW / Mini",
        "Volkswagen / Audi / Volvo",
        "Mercedes-Benz",
        "Dodge / RAM (Hemi Specialists)",
        "Ford / Chevy / GM Daily Drivers"
      ]
    }
  },
  {
    id: "vehicle-electrical-repair",
    title: "Vehicle Electrical Repair",
    subtitle: "Advanced wiring, starter, alternator, and sensor diagnostics",
    image: "https://images.unsplash.com/photo-1632733711679-529326f6db12",
    summary: "Faulty wiring, dead batteries, or phantom power drains? Our advanced electrical diagnostics pinpoints issues without wasting your time.",
    description: "Modern vehicles are highly complex computers on wheels. If you have a sensor acting up, a battery draining overnight, or electrical accessories failing, you need specialized diagnostic tools and expert wiring knowledge. We trace and resolve complex automotive electrical faults with precision.",
    benefits: [
      "Alternator, starter motor, and battery diagnostics & replacements",
      "Wiring harness repairs and computer communication issues",
      "Fuse box, relays, and sensor diagnostics",
      "Window regulators, power locks, and dash console troubleshooting"
    ],
    details: {
      sectionTitle: "Expert Diagnostic Strategy",
      sectionText: "We don't guess or blindly swap parts. We use oscilloscopes, multimeters, and OEM-level scanners to trace the exact source of electrical resistance or voltage drops, ensuring a correct first-time fix.",
      extraServices: [
        "Battery drain tracking (parasitic draw tests)",
        "Aftermarket gauge, light, and accessory wiring",
        "Engine ECU, TCU, and body control module troubleshooting",
        "Euro vehicle electrical coding and adaptation"
      ]
    }
  },
  {
    id: "brake-repair",
    title: "Brake Repair Services",
    subtitle: "Premium pads, rotors, caliper servicing, and brake lines",
    image: "https://images.unsplash.com/photo-1588017530244-c57df911f73b",
    summary: "Squeaking, grinding, or soft pedals? We use high-quality pads and rotors to ensure your car stops safely, every single time.",
    description: "Brakes are your vehicle's most critical safety system. Regular brake maintenance preserves responsiveness and prevents expensive rotor damage. At KG Auto Repair, we offer top-tier brake pad, rotor, caliper, and master cylinder services, utilizing only high-quality friction materials for superior stopping power.",
    benefits: [
      "Premium, low-dust ceramic or semi-metallic brake pad installations",
      "Heavy-duty rotor replacement and precision caliper servicing",
      "Brake fluid flushes and system bleeding to remove air/moisture",
      "ABS sensor diagnostics and brake line replacements"
    ],
    details: {
      sectionTitle: "When Should You Service Your Brakes?",
      sectionText: "Brake components naturally wear down. Watch out for these warning indicators and call us for an inspection:",
      extraServices: [
        "Squealing, grinding, or screeching sounds during braking",
        "The steering wheel or brake pedal shakes/pulsates when slowing down",
        "The brake pedal feels spongy, soft, or goes nearly to the floor",
        "Increased distance required to bring the vehicle to a complete stop"
      ]
    }
  },
  {
    id: "euro-vehicle-repair",
    title: "Euro Vehicle Repair",
    subtitle: "Specialized service for BMW, Mini, VW, Audi, Volvo & Mercedes-Benz",
    image: "https://images.unsplash.com/photo-1601929862217-f1bf94503333",
    summary: "European vehicles require specialized diagnostics and parts. Avoid the high dealership rates with our certified Euro mechanics.",
    description: "European automobiles are engineered for high performance, but they require highly specific maintenance procedures, fluids, and diagnostic tools. We specialize in European vehicle service, offering premium dealership-grade maintenance and complex repairs at affordable local prices.",
    benefits: [
      "Certified technicians who understand European engineering and quirks",
      "OEM or high-quality German parts (Bosch, Liqui Moly, etc.)",
      "Coding, adaptation, and diagnostic scanning using specialty tools",
      "Specialty services for BMW VANOS, Audi TFSI, and VW timing chains"
    ],
    details: {
      sectionTitle: "European Car Expertise",
      sectionText: "We take care of your premium European car as if it were our own. From routine maintenance to intricate engine rebuilds, we deliver exceptional care that preserves your vehicle's warranty and driving dynamics.",
      extraServices: [
        "BMW / Mini oil leaks, water pumps, and cooling system overhauls",
        "Audi / VW intake valve carbon cleaning (walnut blasting/solvent)",
        "Volvo electrical, transmission, and suspension service",
        "Mercedes-Benz fluid services and brake adaptations"
      ]
    }
  },
  {
    id: "oil-changes",
    title: "Oil Changes & Preventative Care",
    subtitle: "Premium synthetic fluids, OEM filters, and multi-point inspections",
    image: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc",
    summary: "Protect your engine and extend its lifespan. We use premium Liqui Moly, Mobil 1, and high-quality filters with full vehicle health checks.",
    description: "Routine oil changes are the single most effective way to protect your engine block and keep your vehicle running smoothly. At KG Auto Repair, we don't just dump oil; we perform a comprehensive check of your fluids, belts, hoses, and tires to intercept potential issues before they leave you stranded.",
    benefits: [
      "Premium full-synthetic, synthetic blend, or diesel oil changes",
      "High-grade OEM or Wix oil filters for optimal filtration",
      "Complimentary under-hood fluid top-offs and tire pressure check",
      "Multi-point digital inspection report with every service"
    ],
    details: {
      sectionTitle: "Full Preventative Inspections",
      sectionText: "We use only premium products to preserve engine tolerances, especially for high-temperature turbochargers and tight European tolerances.",
      extraServices: [
        "Full synthetic oil services (Liqui Moly, Castrol, Mobil 1)",
        "Coolant, brake fluid, transmission fluid, and differential fluid exchanges",
        "Engine air filter and cabin microfilter replacements",
        "Drive belt, serpentine belt, and radiator hose inspections"
      ]
    }
  },
  {
    id: "heat-and-ac-repair",
    title: "Automotive Heat & AC Repair",
    subtitle: "AC recharges, compressor swaps, heater cores, and climate control",
    image: "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767",
    summary: "Stay comfortable in West Virginia winters and summers. We diagnose leak points, replace compressors, and fix heater cores.",
    description: "An auto climate control system is vital for comfort and safety (such as clearing windshield frost on freezing WV mornings). Whether your AC is blowing warm air or your heater is blowing cold, our technicians carry advanced AC recovery equipment to restore your cabin comfort rapidly.",
    benefits: [
      "AC system pressure test, electronic leak detection, and dye injections",
      "R134a and newer eco-friendly refrigerant recharges (EV/hybrid safe)",
      "Compressor, condenser, expansion valve, and evaporator replacements",
      "Heater core swaps, thermostat replacements, and blend door motor fixes"
    ],
    details: {
      sectionTitle: "Comprehensive Comfort Checks",
      sectionText: "WV weather is unforgiving. Keep your climate system operating correctly with our digital system check.",
      extraServices: [
        "Cabin odor extraction and duct sanitization",
        "Blower motor and resistor repairs",
        "Dual-zone climate control computer diagnostics",
        "Coolant leaks and overheating issue diagnostics"
      ]
    }
  }
];

export const reviewsData = [
  {
    id: 1,
    author: "Austin Sanders",
    rating: 5,
    text: "Grant at KG Auto is hands down the most transparent mechanic I have ever worked with. He rebuilt the top end heads of my Ram Hemi and it runs better than when I bought it. Highly recommend his mobile and shop services!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    author: "Emily K.",
    rating: 5,
    text: "My car broke down in Morgantown. Grant arrived within an hour with his mobile unit, diagnosed a failed starter, picked up the part, and replaced it on-site. Incredible service, no towing bill, and fair prices!",
    date: "1 month ago"
  },
  {
    id: 3,
    author: "Marc B. (BMW 335i Owner)",
    rating: 5,
    text: "It is hard to find a local mechanic who actually understands European cars without charging dealer prices. KG Auto diagnosed my BMW oil leak and replaced the valve cover gasket. Honest, professional, and very thorough.",
    date: "3 weeks ago"
  },
  {
    id: 4,
    author: "Sarah Jenkins",
    rating: 5,
    text: "Had a major AC problem right before summer. They did a quick pressure leak test, swapped the compressor, and now it blows ice cold. Super communicative and explained exactly what went wrong. Outstanding auto shop!",
    date: "2 months ago"
  }
];

export const galleryData = [
  {
    id: 1,
    title: "5.7 Hemi Cylinder Head Rebuild",
    description: "Freshly rebuilt and clean heads for a 5.7 Hemi V8 engine.",
    image: "https://static.wixstatic.com/media/9da336_1c1a8308e9ff4f5cbfd0ecbafbcfd890~mv2.jpeg/v1/fill/w_2185,h_783,q_90,enc_avif,quality_auto/9da336_1c1a8308e9ff4f5cbfd0ecbafbcfd890~mv2.jpeg"
  },
  {
    id: 2,
    title: "High Performance Engine Build",
    description: "Complete custom engine block assembly and upgrades in our shop.",
    image: "https://static.wixstatic.com/media/9da336_15be8ca482694880b150df704d43e341~mv2.jpeg/v1/fill/w_2185,h_783,q_90,enc_avif,quality_auto/9da336_15be8ca482694880b150df704d43e341~mv2.jpeg"
  },
  {
    id: 3,
    title: "Mobile Diagnostic Call",
    description: "On-site engine scanning and electrical trace in Morgantown WV.",
    image: "https://static.wixstatic.com/media/9da336_bd0a9e9af5224a108ead8513ee688e7b~mv2.jpg/v1/fill/w_584,h_387,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/9da336_bd0a9e9af5224a108ead8513ee688e7b~mv2.jpg"
  },
  {
    id: 4,
    title: "In-Shop Timing Chain Service",
    description: "Precision timing chain kit replacement on a German Euro engine.",
    image: "https://static.wixstatic.com/media/9da336_766f02875a8346de845745acfef456cd~mv2.jpg/v1/fill/w_584,h_387,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/9da336_766f02875a8346de845745acfef456cd~mv2.jpg"
  }
];

export const submitContactInquiry = async (formData) => {
  try {
    const response = await axios.post(`${API}/inquiries`, formData);
    return response.data;
  } catch (error) {
    console.error("API Inquiry error:", error);
    throw error;
  }
};
